import axios from 'axios';

// Create an Axios instance
const api = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL, // Ensure your backend URL is set in the .env file
  withCredentials: true, // Include cookies in requests if needed
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add a request interceptor to include the JWT token
api.interceptors.request.use((config) => {
  // Get the token from localStorage
  const token = localStorage.getItem('token');

  if (token) {
    // If the token exists, add it to the Authorization header
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});

export default api;
